export default "__VITE_ASSET__41783388__"